import { PageId } from 'constants/pages'

export const enum PageIdStylioSnrs {
  AGE_SNRS = PageId.AGE_SNRS,
  URGE_SNRS = PageId.URGE_SNRS,
  HAIR_COLOR_SNRS = PageId.HAIR_COLOR_SNRS,
  EYES_COLOR_SNRS = PageId.EYES_COLOR_SNRS,
  JEWELRY_SNRS = PageId.JEWELRY_SNRS,
  BODY_SHAPE_SNRS = PageId.BODY_SHAPE_SNRS,
  STYLIO_TO_HELP_SNRS = PageId.STYLIO_TO_HELP_SNRS,
  TALL_SNRS = PageId.TALL_SNRS,
  WEIGHT_SNRS = PageId.WEIGHT_SNRS,
  URGE_2_SNRS = PageId.URGE_2_SNRS,
  SHOPPING_SNRS = PageId.SHOPPING_SNRS,
  STYLE_MOST_MATTERS_SNRS = PageId.STYLE_MOST_MATTERS_SNRS,
  FAVORITE_COLORS_SNRS = PageId.FAVORITE_COLORS_SNRS,
  LIKE_OR_DISLIKE_SNRS = PageId.LIKE_OR_DISLIKE_SNRS,
  LIKE_OR_DISLIKE_11_SNRS = PageId.LIKE_OR_DISLIKE_11_SNRS,
  LIKE_OR_DISLIKE_12_SNRS = PageId.LIKE_OR_DISLIKE_12_SNRS,
  LIKE_OR_DISLIKE_13_SNRS = PageId.LIKE_OR_DISLIKE_13_SNRS,
  LIKE_OR_DISLIKE_14_SNRS = PageId.LIKE_OR_DISLIKE_14_SNRS,
  LIKE_OR_DISLIKE_15_SNRS = PageId.LIKE_OR_DISLIKE_15_SNRS,
  LIKE_OR_DISLIKE_16_SNRS = PageId.LIKE_OR_DISLIKE_16_SNRS,
  LIKE_OR_DISLIKE_17_SNRS = PageId.LIKE_OR_DISLIKE_17_SNRS,
  STYLES_FEEL_LIKE_YOU_SNRS = PageId.STYLES_FEEL_LIKE_YOU_SNRS,
  URGE_4_SNRS = PageId.URGE_4_SNRS,
  BRAND_SNRS = PageId.BRAND_SNRS,
  FIND_NEW_CLOTHES_SNRS = PageId.FIND_NEW_CLOTHES_SNRS,
  NOTHING_TO_WEAR_SNRS = PageId.NOTHING_TO_WEAR_SNRS,
  OLD_CLOTHES_SNRS = PageId.OLD_CLOTHES_SNRS,
  COMBINE_CLOTHES_SNRS = PageId.COMBINE_CLOTHES_SNRS,
  OUTFIT_LOOK_SNRS = PageId.OUTFIT_LOOK_SNRS,
  OPTIMIZE_BUDGET_SNRS = PageId.OPTIMIZE_BUDGET_SNRS,
  EVERYDAY_LIFESTYLE_SNRS = PageId.EVERYDAY_LIFESTYLE_SNRS,
  CLIMAT_SNRS = PageId.CLIMAT_SNRS,
  URGE_3_SNRS = PageId.URGE_3_SNRS,
  PREPARE_FLOW_SNRS = PageId.PREPARE_FLOW_SNRS,
  EMAIL_SNRS = PageId.EMAIL_SNRS,
  EMAIL_CONSENT_SNRS = PageId.EMAIL_CONSENT_SNRS,
  SUBSCRIPTIONS_SNRS = PageId.SUBSCRIPTIONS_SNRS,
  CANCEL_OFFER_SNRS = PageId.CANCEL_OFFER_SNRS,
  SUB_UPSELL_SNRS = PageId.SUB_UPSELL_SNRS,
  UPSELL_SNRS = PageId.UPSELL_SNRS,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_SNRS = PageId.DOWNLOAD_SNRS,
}
